import { takeLatest, put, all, fork } from 'redux-saga/effects'
import { push } from "connected-react-router"

import * as actions from '../actions/actions'

export default function* routerSaga() {
  yield all([
    fork(watchHomePageMenuRequest),
    fork(watchUserPageMenuRequest),
    fork(watchFaqrPageMenuRequest),
    fork(watchFilePageMenuRequest),
    fork(watchBankPageMenuRequest),
    fork(watchCorporatePageMenuRequest),
    fork(watchCampaignPageMenuRequest),
    fork(watchReportPageMenuRequest),
    fork(watchUserCreatePageRequest),
    fork(watchCorporateCreatePagePageRequest),
    fork(watchCampaignCreatePageRequest),
    fork(watchFileUploadPageRequest),
    fork(watchProfilePageRequest),
    fork(watchCreateContoCorrenteRequest),
    fork(watchEditContoCorrenteRequest),
  ]);
}

function* watchHomePageMenuRequest() {
  yield takeLatest(
    actions.HOME_PAGE_MENU_REQUEST,
    homePageMenuRequest
  )
}

function* homePageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/home`))
}

function* watchFaqrPageMenuRequest() {
  yield takeLatest(
      actions.FAQ_PAGE_MENU_REQUEST,
      faqPageMenuRequest
  )
}

function* faqPageMenuRequest() {
  yield put(push(`/faq`))
}

function* watchUserPageMenuRequest() {
  yield takeLatest(
    actions.USER_PAGE_MENU_REQUEST,
    userPageMenuRequest
  )
}

function* userPageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/user`))
}

function* watchFilePageMenuRequest() {
  yield takeLatest(
    actions.FILE_PAGE_MENU_REQUEST,
    filePageMenuRequest
  )
}

function* filePageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/file`))
}

function* watchBankPageMenuRequest() {
  yield takeLatest(
    actions.BANK_PAGE_MENU_REQUEST,
    bankPageMenuRequest
  )
}

function* bankPageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/bank`))
}

function* watchCorporatePageMenuRequest() {
  yield takeLatest(
    actions.CORPORATE_PAGE_MENU_REQUEST,
    corporatePageMenuRequest
  )
}

function* corporatePageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/corporate`))
}

function* watchCampaignPageMenuRequest() {
  yield takeLatest(
    actions.CAMPAIGN_PAGE_MENU_REQUEST,
    campaignPageMenuRequest
  )
}

function* campaignPageMenuRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put(push(`/campaign`))
}

function* watchReportPageMenuRequest() {
  yield takeLatest(
      actions.REPORT_PAGE_MENU_REQUEST,
      reportPageMenuRequest
  )
}

function* reportPageMenuRequest() {
  yield put({ type: actions.CREATE_REPORT_CLEAN})
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  yield put(push(`/report`))
}

function* watchUserCreatePageRequest() {
  yield takeLatest(
    actions.USER_CREATE_PAGE_REQUEST,
    userCreatePageRequest
  )
}

function* userCreatePageRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put(push(`/user/create`))
}

function* watchCorporateCreatePagePageRequest() {
  yield takeLatest(
    actions.CORPORATE_CREATE_PAGE_REQUEST,
    corporateCreatePagePageRequest
  )
}

function* corporateCreatePagePageRequest() {
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put(push(`/corporate/create`))
}

function* watchCampaignCreatePageRequest() {
  yield takeLatest(
    actions.CAMPAIGN_CREATE_PAGE_REQUEST,
    campaignCreatePageRequest
  )
}

function* campaignCreatePageRequest() {
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put(push(`/campaign/create`))
}


function* watchFileUploadPageRequest() {
  yield takeLatest(
    actions.FILE_UPLOAD_PAGE_REQUEST,
    fileUploadPageRequest
  )
}

function* fileUploadPageRequest() {
  yield put({ type: actions.FILE_UPLOAD_CLEAN})
  yield put(push(`/file/upload`))
}

function* watchProfilePageRequest() {
  yield takeLatest(
    actions.PROFILE_PAGE_MENU_REQUEST,
    profilePageMenuRequest
  )
}

function* profilePageMenuRequest(username) {
  yield put({ type: actions.CREATE_USER_CLEAN})
  yield put({ type: actions.EDIT_USER_CLEAN})
  yield put({ type: actions.DETAIL_USER_CLEAN})
  yield put({ type: actions.CREATE_BANK_CLEAN})
  yield put({ type: actions.EDIT_BANK_CLEAN})
  yield put({ type: actions.DETAIL_BANK_CLEAN})
  yield put({ type: actions.CREATE_CORPORATE_CLEAN})
  yield put({ type: actions.EDIT_CORPORATE_CLEAN})
  yield put({ type: actions.DETAIL_CORPORATE_CLEAN})
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN})
  yield put({ type: actions.EDIT_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_CAMPAIGN_CLEAN})
  yield put({ type: actions.DETAIL_PLICK_CLEAN})
  // yield put({ type: actions.EDIT_PROFILE_CLEAN})
  yield put({ type: actions.FETCH_PROFILE_EDIT_REQUEST, value: username.value})
  // yield put(push(`/profile`))
}

function* watchCreateContoCorrenteRequest() {
  yield takeLatest(
      actions.CREATE_CONTO_CORRENTE_PAGE_REQUEST,
      createContoCorrenteRequest
  )
}

function* createContoCorrenteRequest(corporateData) {
  yield put({ type: actions.CREATE_CONTO_CORRENTE_CLEAN})
  yield put(push(`/corporate/edit/${corporateData.value.corporateId}/contoCorrente`))
}

function* watchEditContoCorrenteRequest() {
  yield takeLatest(
      actions.EDIT_CONTO_CORRENTE_PAGE_REQUEST,
      editContoCorrenteRequest
  )
}

function* editContoCorrenteRequest(corporateData) {
  yield put({ type: actions.EDIT_CONTO_CORRENTE_CLEAN})
  yield put(push(`/corporate/edit/${corporateData.value.corporate}/contoCorrente/${corporateData.value.contoCorrente}`))
}